import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-route',
  templateUrl: './error-route.component.html',
  styleUrls: ['./error-route.component.scss'],
})
export class ErrorRouteComponent implements OnInit {
  error: string;

  ngOnInit(): void {
    if (history?.state?.error?.message) {
      this.error = history.state.error.message;
    } else {
      this.error = 'This MU3 form is no longer available.';
    }
  }
}
